import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { APP_PATHS, SEARCH_COMPANIES_TABLE_COLUMNS_CONFIG } from '@core/constants';
import { PartnerModel } from '@core/models';
import { TableComponent } from '@custom-components/general/table/table.component';

@Component({
  selector: 'xemex-companies-content',
  imports: [TableComponent],
  templateUrl: './companies-content.component.html',
  styleUrl: './companies-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompaniesContentComponent {
  partners = input<PartnerModel[]>([]);
  loading = input(false);

  protected readonly columns = SEARCH_COMPANIES_TABLE_COLUMNS_CONFIG;

  protected readonly tableData = computed(
    () => this.partners() as unknown as Record<string, unknown>[],
  );

  protected readonly rowLink = (row: Record<string, unknown>) => [
    '/',
    APP_PATHS.Partners,
    row['partnerOid'] as string,
  ];
}
